import { isProd, url } from '@/config';
import ajax from '@/utils/request';
import PaWebJs from '@/utils/paweb';
import rsa from '@/utils/rsa';
import { setStorage } from './index';
import PACaptcha from '@/utils/PACaptcha';
import closeImg from './login-image/close.png';
import checkedImg from './login-image/checked.png';
import uncheckImg from './login-image/uncheck.png';
import personIconImg from './login-image/person-icon.png';
import pwdIconImg from './login-image/pwd-icon.png';
import phoneIconImg from './login-image/phone-icon.png';
import codeIconImg from './login-image/code-icon.png';

let oninput = 'oninput'
if(/Microsoft\s*Internet\s*Explorer/i.test(navigator.appName)) {
  oninput = 'onchange'
  const ieMatch = /msie\s+(\d+)/i.exec(navigator.userAgent)
  if(ieMatch && ieMatch[1] > 9) {
    oninput = 'oninput'
  }
}

const cssStr = `.login-box-wrap, .login-box-wrap .captcha-wrap {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .6);
}
.login-box-wrap * {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  border: 0;
  outline: none;
  list-style: none;
}
.login-box-main, .captcha-wrap .captcha-main {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 400px;
  height: 444px;
  margin: auto;
  background: #fff;
  border-radius: 4px;
}
.login-box-main .login-close, .captcha-main .captcha-close {
  position: absolute;
  top: 8px;
  right: 6px;
  width: 29px;
  height: 29px;
  cursor: pointer;
  user-select: none;
}
.login-box-main .login-title {
  width: 300px;
  height: 70px;
  margin: 22px auto 0;
  font-size: 0;
  text-align: center;
  border-bottom: 2px solid #F1F1F1;
}
.login-box-main .login-title li {
  display: inline-block;
  height: 70px;
  margin: 0 25px;
  color: #333;
  font-size: 20px;
  line-height: 70px;
  border-bottom: 2px solid transparent;
  cursor: pointer;
}
.login-box-main .login-title .title-active {
  color: #F36C28;
  border-color: #F36C28;
  cursor: default;
}
.login-box-main .login-panel {
  padding: 6px 0;
}
.login-box-main .login-input-wrap {
  position: relative;
  width: 300px;
  height: 40px;
  margin: 20px auto 0;
  border: 1px solid #ddd;
  border-radius: 2px;
  overflow: hidden;
}
.login-box-main .login-input-wrap img {
  position: absolute;
  top: 7px;
  left: 12px;
  width: 24px;
  height: 24px;
}
.login-box-main .login-input-wrap input {
  display: block;
  width: 100%;
  height: 100%;
  padding-left: 41px;
  padding-right: 6px;
  font-size: 14px;
}
.login-box-main .login-item {
  width: 300px;
  margin: 20px auto 0;
  overflow: hidden;
}
.login-box-main .login-item .login-input-wrap {
  float: left;
  width: 200px;
  margin-top: 0;
}
.login-box-main .dynamic-btn {
  float: right;
  width: 90px;
  height: 40px;
  color: #fff;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  background: #007aff;
  border-radius: 2px;
  cursor: pointer;
  user-select: none;
}
.login-box-main .dynamic-btn.not-click {
  background: #84bfff;
  cursor: default;
}
.login-box-main .login-tips {
  height: 26px;
  color: #f22;
  font-size: 12px;
  line-height: 26px;
  text-align: center;
  overflow: hidden;
}
.login-box-main .login-submit {
  position: relative;
  width: 300px;
  height: 44px;
  margin: 0 auto 18px;
  color: #fff;
  font-size: 16px;
  line-height: 44px;
  text-align: center;
  background: #F36C28;
  border-radius: 4px;
  cursor: pointer;
}

.login-box-main .login-protocol {
  display: block;
  width: 300px;
  margin: 4px auto 0;
  overflow: hidden;
}
.login-box-main .login-check-img {
  float: left;
  width: 16px;
  height: 16px;
  cursor: pointer;
}
.login-box-main .login-check-img img {
  display: block;
  width: 16px;
  height: 16px;
}
.login-box-main .login-check-img .checked-img {
  display: none;
}
.login-box-main .login-check-img .unchecked-img {
  display: block;
}
.login-box-main .login-protocol > input:checked + .login-check-img .checked-img {
  display: block;
}
.login-box-main .login-protocol > input:checked + .login-check-img .unchecked-img {
  display: none;
}
.login-box-main .login-protocol-main {
  float: right;
  width: 276px;
  color: #616161;
  font-size: 14px;
  line-height: 16px;
}
.login-box-main .login-protocol-main a {
  color: #fc6802;
  text-decoration: none;
}
.login-box-main .login-protocol-main a:hover {
  text-decoration: underline;
}
.login-box-main .login-register {
  position: absolute;
  bottom: 30px;
  left: 50px;
  color: #333;
  font-size: 12px;
  letter-spacing: .18px;
  text-decoration: underline;
}
.login-box-main .login-forget {
  position: absolute;
  bottom: 30px;
  right: 50px;
  color: #333;
  font-size: 12px;
  letter-spacing: .18px;
  text-decoration: underline;
}
.login-box-wrap .captcha-wrap {
  z-index: 9999;
}
.login-box-wrap .captcha-main {
  width: 330px;
  height: 195px;
  border-radius: 2px;
}
.captcha-main .captcha-title {
  width: 260px;
  height: 64px;
  margin: 5px auto 0;
  color: #171717;
  font-size: 14px;
  line-height: 64px;
}
.captcha-main .captcha-code {
  width: 260px;
  height: 30px;
  margin: auto;
}
.captcha-main .captcha-code input {
  float: left;
  height: 30px;
  color: #9a9a9a;
  font-size: 14px;
  border-bottom: 1px solid #ddd;
}
.captcha-main .captcha-code img {
  float: right;
  width: 85px;
  height: 30px;
}
.captcha-main .change-captcha {
  width: 260px;
  margin: 6px auto 16px;
  color: #616161;
  font-size: 12px;
  line-height: 14px;
  text-align: right;
}
.captcha-main .submit-captcha {
  width: 260px;
  height: 40px;
  margin: auto;
  color: #fff;
  font-size: 16px;
  line-height: 40px;
  text-align: center;
  background: #f16c34;
  border-radius: 2px;
  cursor: pointer;
}`;

const htmlStr = `<div class="login-box-wrap">
<div class="login-box-main">
  <img class="login-close" src="close.png">
  <ul class="login-title">
    <li
      data-event-param="登录框-密码登录tab"
      data-event-name="登录框-密码登录tab"
      otitle="登录框-密码登录tab"
      otype="click"
      data-event-type="click"
      class="title-active">密码登录</li>
    <li
      data-event-param="登录框-短信登录tab"
      data-event-name="登录框-短信登录tab"
      otitle="登录框-短信登录tab"
      otype="click"
      data-event-type="click"
    >短信登录</li>
  </ul>
  <div class="login-panel">
    <div class="login-input-wrap">
      <img src="person-icon.png">
      <input type="text" placeholder="请输入手机号/用户名/身份证号">
    </div>
    <div class="login-input-wrap">
      <img src="pwd-icon.png">
      <input type="password" placeholder="请输入密码">
    </div>
  </div>
  <div class="login-panel" style="display: none;">
    <div class="login-input-wrap">
      <img src="phone-icon.png">
      <input type="text" maxlength="11" placeholder="请输入手机号">
    </div>
    <div class="login-item">
      <div class="login-input-wrap">
        <img src="code-icon.png">
        <input type="text" placeholder="请输入动态密码">
      </div>
      <div
        data-event-param="登录框-动态密码"
        data-event-name="登录框-动态密码"
        otitle="登录框-动态密码"
        otype="click"
        data-event-type="click"
        class="dynamic-btn">动态密码</div>
    </div>
  </div>
  <div class="login-tips"></div>
  <div
    data-event-param="登录框-登录"
    data-event-name="登录框-登录"
    otitle="登录框-登录"
    otype="click"
    data-event-type="click"
    class="login-submit">登&nbsp;录</div>
  <label class="login-protocol">
    <input type="checkbox" style="display:none;">
    <div class="login-check-img">
      <img class="checked-img" src="checked.png">
      <img class="unchecked-img" src="uncheck.png">
    </div>
    <div class="login-protocol-main">
      同意
      <a
        data-event-param="登录框-平安一账通会员服务协议"
        data-event-name="登录框-平安一账通会员服务协议"
        otitle="登录框-平安一账通会员服务协议"
        otype="click"
        data-event-type="click"
        href="https://paicc-core.pingan.com.cn/paicc/protocol.html#/" target="_blank">
        《平安一账通会员服务协议》
      </a>
      、
      <a
        data-event-param="登录框-平安官网隐私政策"
        data-event-name="登录框-平安官网隐私政策"
        otitle="登录框-平安官网隐私政策"
        otype="click"
        data-event-type="click"
        href="https://pingan.com/privacy/pa_official_privacy_agreement.html" target="_blank">
        《平安官网隐私政策》
      </a>
    </div>
  </label>
  <label class="login-protocol">
    <input type="checkbox" style="display:none;">
    <div class="login-check-img">
      <img class="checked-img" src="checked.png">
      <img class="unchecked-img" src="uncheck.png">
    </div>
    <div class="login-protocol-main">
      同意
      <a
        data-event-param="登录框-平安官网扩展业务功能协议"
        data-event-name="登录框-平安官网扩展业务功能协议"
        otitle="登录框-平安官网扩展业务功能协议"
        otype="click"
        data-event-type="click"
        href="https://www.pingan.com/privacy/pa_official_expand_business_protocol.html" target="_blank">
        《平安官网扩展业务功能协议》
      </a>
    </div>
  </label>
  <a
    data-event-param="登录框-立即注册"
    data-event-name="登录框-立即注册"
    otitle="登录框-立即注册"
    otype="click"
    data-event-type="click"
    class="login-register" href="https://paicc-core.pingan.com.cn/paicc-core-web/webapi/mergeRegister.do?appId=11064&paramType=web&withFiveKey=Y" target="_blank">立即注册</a>
  <a
    data-event-param="登录框-忘记密码"
    data-event-name="登录框-忘记密码"
    otitle="登录框-忘记密码"
    otype="click"
    data-event-type="click"
    class="login-forget" href="https://paicc-core.pingan.com.cn/paicc-core-web/webapi/resetPwdH5View.do?paramType=web&appId=11064&paramType=web&withFiveKey=Y" target="_blank">忘记密码</a>
</div>
<div class="captcha-wrap" style="display:none;">
  <div class="captcha-main">
    <img class="captcha-close" src="close.png">
    <div class="captcha-title">为了您的账号安全，请进行身份验证</div>
    <div class="captcha-code">
      <input type="text" placeholder="验证码不区分大小写">
      <img src="#">
    </div>
    <div class="change-captcha">点击更换验证码</div>
    <div class="submit-captcha">确认</div>
  </div>
</div>
</div>`;

const loginBox = {
  wrap: null,
  tabIndex: 0,
  inputs: {
    nameInput: null,
    pwdInput: null,
    phoneInput: null,
    codeInput: null
  },
  captchaInput: null,
  submitMaskIsShow: true,
  dynamicCodeBtn: null,
  countDownCnt: -1,
  captchaWrap: null,
  pac: {},
  logining: false,
  pacing: false,
  successCallBack: null,
  openLogin(cb) {
    this.successCallBack = cb
    const styleId = 'pa-login-box-css-id-forjs'
    if(!document.getElementById(styleId)) {
      const s = document.createElement('style')
      s.id = styleId
      s.innerHTML = cssStr
      document.getElementsByTagName('head')[0].appendChild(s)
    }
    let wrap = document.createElement('div')
    const imgMap = {
      'close.png': closeImg,
      'checked.png': checkedImg,
      'uncheck.png': uncheckImg,
      'person-icon.png': personIconImg,
      'pwd-icon.png': pwdIconImg,
      'phone-icon.png': phoneIconImg,
      'code-icon.png': codeIconImg
    }
    let newHtmlStr = htmlStr
    Object.keys(imgMap).forEach(k => {
      newHtmlStr = newHtmlStr.replace(new RegExp(`(\\ssrc\\s*=\\s*['"])${k}(\\s*['"])`, 'ig'), (_, p1, p2) => `${p1}${imgMap[k]}${p2}`)
    })
    wrap.innerHTML = newHtmlStr
    wrap = wrap.childNodes[0]
    document.body.appendChild(wrap)
    this.wrap = wrap
    this.init(wrap)
  },
  init(wrap) {
    const inputs = wrap.querySelectorAll('.login-input-wrap input')
    this.inputs = {
      nameInput: inputs[0],
      pwdInput: inputs[1],
      phoneInput: inputs[2],
      codeInput: inputs[3]
    }
    this.captchaWrap = wrap.querySelector('.captcha-wrap')
    this.captchaInput = wrap.querySelector('.captcha-code input')
    this.dynamicCodeBtn = wrap.querySelector('.dynamic-btn')

    this.addEvent()
    this.addSlider()
  },
  addEvent() {
    const wrap = this.wrap
    this.closeEvent(wrap)
    this.tabEvent(wrap)
    this.protocolSelectEvent(wrap)
    this.inputEvent()
    this.dynamicCodeEvent()
    this.loginSubmitEvent(wrap)
    this.submitCaptchaEvent(wrap)
    this.refreshCaptchaEvent(wrap)
  },
  tabEvent(wrap) {
    const tabWrap = wrap.querySelector('.login-title')
    const tabs = tabWrap.querySelectorAll('li')
    const loginPanels = wrap.querySelectorAll('.login-panel')

    tabWrap.onclick = e => {
      if(e.target.tagName.toUpperCase() === 'LI') {
        if(e.target.className.indexOf('title-active') < 0) {
          this.tabIndex = 0
          if(tabs[1] === e.target) {
            this.tabIndex = 1
          }

          tabs[0].className = ''
          tabs[1].className = ''
          loginPanels[0].style.display = 'none'
          loginPanels[1].style.display = 'none'
          tabs[this.tabIndex].className = 'title-active'
          loginPanels[this.tabIndex].style.display = 'block'
          this.showTips()
          this.captchaInput.value = ''
        }
      }
    }
  },
  protocolSelectEvent(wrap) {
    const protocols = wrap.querySelectorAll('.login-protocol input')

    protocols[0].onchange = () => {
      this.showTips()
      if(protocols[0].checked) {
        protocols[1].checked = true
      }
    }
  },
  inputEvent() {
    this.inputs.nameInput[oninput] = () => {
      this.showTips()
    }
    this.inputs.pwdInput[oninput] = () => {
      this.showTips()
    }
    this.inputs.phoneInput[oninput] = () => {
      this.showTips()
    }
    this.inputs.codeInput[oninput] = () => {
      this.showTips()
    }
  },
  dynamicCodeEvent() {
    this.dynamicCodeBtn.onclick = () => {
      if(this.countDownCnt > -1) {
        return
      }
      this.getVerifyCode()
    }
  },
  submitCaptchaEvent(wrap) {
    wrap.querySelector('.submit-captcha').onclick = () => {
      if(this.tabIndex) {
        this.getVerifyCode()
      } else {
        this.pwdLogin(true)
      }
      this.captchaWrap.style.display = 'none'
    }
  },
  refreshCaptchaEvent(wrap) {
    wrap.querySelector('.captcha-code > img').onclick = () => {
      let name = this.inputs.nameInput.value.trim()
      if(this.tabIndex) {
        name = this.inputs.phoneInput.value.trim()
      }
      this.reloadImageCaptcha(name).then(({ image } = {}) => {
        image = image.replace(/^\s*data:img\//, 'data:image/')
        this.captchaWrap.querySelector('.captcha-code img').src = image
      })
    }
  },
  loginSubmitEvent(wrap) {
    wrap.querySelector('.login-submit').onclick = () => {
      if(this.logining || this.pacing) {
        return
      }
      const protocol = document.querySelector('.login-protocol input')
      if(!protocol.checked) {
        return this.showTips('请阅读并同意相关服务协议')
      }
      const name = this.inputs.nameInput.value.trim()
      const phone = this.inputs.phoneInput.value.trim()
      if(this.tabIndex) {
        if(!/^\s*1\d{10}\s*$/.test(phone)) {
          return this.showTips('手机号码格式不正确')
        }
      } else {
        if(!name) {
          return this.showTips('账号不能为空')
        }
        if(!this.inputs.pwdInput.value.trim()) {
          return this.showTips('密码不能为空')
        }
      }

      this.checkShowSlider(this.tabIndex ? phone : name).then((data) => {
        if(+data === 1) {
          this.pacing = true
          this.pac._cfg.clickBtnDOM.getElementsByTagName('div')[0].click()
        } else {
          if(this.tabIndex) {
            this.smsLogin()
          } else {
            this.pwdLogin()
          }
        }
      }).catch(({ msg = '' } = {}) => {
        this.showTips(msg)
      })
    }
  },
  closeEvent(wrap) {
    wrap.querySelector('.login-close').onclick = () => wrap.parentNode.removeChild(wrap)
    wrap.querySelector('.captcha-close').onclick = () => { this.captchaWrap.style.display = 'none' }
  },
  addSlider() {
    this.pac = new PACaptcha({
      getData: (url, params) => ajax(url, { keepResponse: true, params }), // 必填, Function Get型ajax: (url, params) => Promise
      areaDOM: this.wrap.querySelector('.login-box-main'),
      clickBtnDOM: document.createElement('div'),
      isProd
    })
    this.pac.on('success', () => {
      this.pacing = false
      if(this.tabIndex) {
        this.smsLogin()
      } else {
        this.pwdLogin()
      }
    })
    this.pac.on('error', () => {
      this.pacing = false
      console.log('error')
    })
    this.pac.on('close', () => {
      this.pacing = false
      console.log('close')
    })
  },
  pwdLogin(noVeri) {
    const name = this.inputs.nameInput.value.trim()
    const pwd = this.inputs.pwdInput.value.trim()
    const captchaCode = this.captchaInput.value.trim() || ''

    const loginFunc = () => {
      this.logining = true
      this.loginAccount(name, pwd, captchaCode, +this.wrap.querySelectorAll('.login-protocol input')[1].checked).then((userInfo = {}) => {
        this.logining = false
        this.loginSuccess(userInfo)
      }).catch(({ msg = '' } = {}) => {
        this.logining = false
        this.showTips(msg)
      })
    }

    if(noVeri) {
      return loginFunc()
    }

    this.imageCaptcha(name, 1).then(({ image = '' } = {}) => {
      image = image.replace(/^\s*data:img\//, 'data:image/')
      this.captchaInput.value = ''
      if(image) {
        this.captchaWrap.querySelector('.captcha-code img').src = image
        this.captchaWrap.style.display = 'block'
      } else {
        loginFunc()
      }
    }).catch(({ msg = '' } = {}) => {
      this.showTips(msg)
    })
  },
  smsLogin() {
    const phone = this.inputs.phoneInput.value.trim()
    const code = this.inputs.codeInput.value.trim()
    this.logining = true
    this.loginOneCard(phone, code, +this.wrap.querySelectorAll('.login-protocol input')[1].checked).then((userInfo = {}) => {
      this.logining = false
      this.loginSuccess(userInfo)
    }).catch(({ msg = '' } = {}) => {
      this.logining = false
      this.showTips(msg)
    })
  },
  loginSuccess(data) {
    setStorage('loginWay', this.tabIndex ? 'sms' : 'account');
    setStorage('user_id', data.user_id);
    setStorage('login_token', data.login_token || '');
    setStorage('name',data.name);
    setStorage('phone', data.phone);

    this.wrap.parentNode.removeChild(this.wrap)
    this.successCallBack && this.successCallBack()
  },
  showTips(text) {
    this.wrap.querySelector('.login-tips').innerHTML = text || ''
  },
  countDown(cnt) {
    this.countDownCnt = cnt
    if(this.countDownCnt < 0) {
      this.dynamicCodeBtn.className = 'dynamic-btn'
      this.dynamicCodeBtn.innerHTML = '动态密码'
      return
    }
    if(`${this.dynamicCodeBtn.className} `.indexOf(' not-click ') < 0) {
      this.dynamicCodeBtn.className += ' not-click'
    }
    this.dynamicCodeBtn.innerHTML = `${this.countDownCnt}s`
    setTimeout(() => this.countDown(this.countDownCnt - 1), 1000)
  },
  getVerifyCode() {
    if(this.countDownCnt > -1) {
      return
    }
    const phone = this.inputs.phoneInput.value.trim()
    const captchaCode = this.captchaInput.value.trim()
    if(/^\s*1\d{10}\s*$/.test(phone)) {
      this.getPhoneVeri(phone, captchaCode).then(({ image = '' } = {}) => {
        image = image.replace(/^\s*data:img\//, 'data:image/')
        this.captchaInput.value = ''
        if(image) {
          this.captchaWrap.querySelector('.captcha-code img').src = image
          this.captchaWrap.style.display = 'block'
        } else {
          this.countDown(60)
        }
      }).catch(({ msg = '' } = {}) => {
        this.showTips(msg)
      })
    } else {
      this.showTips('手机号码格式不正确')
    }
  },
  // 是否需要显示滑块
  checkShowSlider(login_name = '') {
    return ajax(url.isSlideToUser, {
      params: {
        login_name
      }
    })
  },
  // 验证码
  getPhoneVeri(login_name = '', captchaCode = '') {
    const getPhoneCode = () => ajax(url.captcha, {
      method: 'post',
      data: {
        login_name,
        image: captchaCode
      }
    })
    if(captchaCode) {
      return getPhoneCode()
    }
    return this.imageCaptcha(login_name).then(({ image } = {}) => {
      if(image) {
        return { image }
      }
      return getPhoneCode()
    })
  },
  // 密码登录
  loginAccount(login_name = '', login_pwd = '', image = '', marketingAgree) {
    return ajax(url.login, {
      method: 'post',
      data: {
        login_name,
        login_pwd: rsa.encrypt(login_pwd),
        image,
        sourceType: 'PC',
        login_cookie: document.cookie,
        marketing_agree: +marketingAgree === 1 ? 1 : 0,
        jtSafeKey: new PaWebJs().get()
      }
    })
  },
  // 一账通登录
  loginOneCard(login_name = '', captcha = '', marketingAgree) {
    return ajax(url.opt, {
      method: 'post',
      data: {
        login_name,
        captcha,
        marketing_agree: +marketingAgree === 1 ? 1 : 0,
        login_cookie: document.cookie,
        jtSafeKey: new PaWebJs().get()
      }
    })
  },
  // 图形验证码
  imageCaptcha(login_name = '', type = 2) {
    return ajax(url.imageCaptcha, {
      method: 'post',
      data: {
        login_name,
        type
      }
    })
  },
  // 重新加载 图形验证码
  reloadImageCaptcha(login_name = '') {
    return ajax(url.reloadImage , {
      method: 'post',
      data: {
        login_name
      }
    })
  }
};

export default loginBox.openLogin.bind(loginBox)
